import {
  createComponentAdmin,
  PublishesTo,
  SubscribesTo,
  scrollToDescription,
  OptionalString,
  type SchemaTypeHelper,
} from '@backstage-components/base';
import {Static, Type} from '@sinclair/typebox';

export const reactName = 'ButtonOverlay';
export const name = 'Button Overlay';
export const description = reactName;

const schema = Type.Object(
  {
    href: OptionalString('Link Url'),
  },
  {
    dependencies: {
      href: {
        properties: {
          isExternal: Type.Boolean({
            default: false,
            title: 'Open Link in New Tab?',
          }),
        },
      },
    },
  }
);

const uiSchema = {
  'ui:order': ['href', 'isExternal', '*'],
};

const defaultFieldData: Static<typeof schema> = {};

const instructions = Type.Union([
  SubscribesTo({
    topic: `${reactName}:click`,
    description: 'Click button overlay (virtually)',
  }),
  SubscribesTo({
    topic: `${reactName}:scrollTo`,
    description: scrollToDescription,
    meta: {
      scrollX: Type.Optional(Type.String()),
      scrollY: Type.Optional(Type.String()),
      anchorElId: Type.Optional(Type.String()),
      elementId: Type.Optional(Type.String()),
    },
  }),
  PublishesTo({
    topic: `${reactName}:on-click`,
    description: 'Button overlay has been clicked',
    meta: {
      href: OptionalString({
        description: 'The href of the button overlay',
      }),
    },
  }),
  PublishesTo({
    topic: `${reactName}:on-focus`,
    description: 'Button has been focused',
  }),
  PublishesTo({
    topic: `${reactName}:on-mouseenter`,
    description: 'Button has been moused over (hovered)',
  }),
  PublishesTo({
    topic: `${reactName}:on-mouseleave`,
    description: 'Button has been moused out (unhovered)',
  }),
]);

const positionRestrictions = {
  disallowedDescendants: [
    reactName,
    'AccessCode',
    'PublicAccessCode',
    'Button',
    'Chat',
    'Checkbox',
    'CnnQuiz',
    'CnnxLanding',
    'Intercom',
    'Link',
    'PeacockBackground',
    'PfLockerRoom',
    'Radio',
    'Switch',
    'TextInput',
    'WbdScreeningBackground',
  ],
};

export const ComponentDefinition = createComponentAdmin({
  id: 'a887b03d-ff07-4a86-bab8-df52acdb236f',
  reactName,
  name,
  slug: reactName,
  description,
  version: 1,
  defaultFieldData,
  slotConfiguration: {
    items: {maxModules: 100, displayWidth: 12, title: 'Modules'},
  },
  schema,
  uiSchema,
  instructions,
  category: 'layout',
  positionRestrictions,
})
  .withAnimationStates()
  .withStyles()
  .build();

export type SchemaType = SchemaTypeHelper<typeof ComponentDefinition>;
